import React from "react";
import PolicyLayout from "./PolicyLayout";

const sections = [
  <><b>Alpaago</b> values your privacy and is committed to protecting your personal data. We collect information solely for order processing, communication, and service improvement.</>,
  <>We never sell or share your data with third parties, except as required by law or for payment processing through trusted partners.</>,
  <>Your data is stored securely, and you may contact us anytime to update or request deletion of your information.</>,
  <>For privacy inquiries, email <b>contact@alpaago.com</b>.</>,
];

export default function PrivacyPolicy() {
  return <PolicyLayout title="Privacy Policy" sections={sections} />;
}
